import React from 'react'
import { useNavigate } from 'react-router-dom';
import SubNav from '../../../Shared/SubNav';
import 'react-multi-carousel/lib/styles.css';
import Carousel from 'react-multi-carousel';
import socket from '../../../context/socket';

export const StayConnected = () => {
  const roomId = new URLSearchParams(window.location.search).get("clientId");
  const navigate = useNavigate();

  const handleNext = () => {
    const nextUrl = "/address-proof?clientId=" + roomId;
    socket.emit("navigate", { room: roomId, url: nextUrl });
    navigate(nextUrl);
  };

  const handleBack = () => {
    const prevUrl = "/refer-friends?clientId=" + roomId;
    socket.emit("navigate", { room: roomId, url: prevUrl });
    navigate(prevUrl);
  };

  return (
    <>


      <div class="container minht5">
        <div class="row ">
          <div class="col-lg-8 col-md-12">
            <h2>Stay connected!</h2>
            <p class="fs-18">Discover our social media content to explore more about our company and our way</p>
          </div>
          <div class="col-lg-4  col-md-12 text-lg-end pt-2">
            <span><a target='_blank' href='https://www.instagram.com/finedge_official/
'><img src="assets/images/instagram-circle.svg" alt="" /></a></span>
            <span><a target='_blank' href='https://www.linkedin.com/company/finedge-official/?viewAsMember=true
'><img src="assets/images/linkdein-circle.svg" alt="" /></a></span>
            <span><a target='_blank' href='https://www.facebook.com/FinEdgeOfficial
'><img src="assets/images/facebook-circle.svg" alt="" /></a></span>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="home-demo">
              {/* <div class="owl-carousel owl-theme">
                            <div class="item">
                                <img src="assets/images/investment.svg" alt=""/>
                            </div>
                            <div class="item">
                                <img src="assets/images/determine.svg" alt=""/>
                            </div>
                            <div class="item">
                                <img src="assets/images/5-question.svg" alt=""/>
                            </div>
                            <div class="item">
                                <img src="assets/images/investment.svg" alt=""/>
                            </div>
                            <div class="item">
                                <img src="assets/images/determine.svg" alt=""/>
                            </div>
                            <div class="item">
                                <img src="assets/images/5-question.svg" alt=""/>
                            </div>
                            <div class="item">
                                <img src="assets/images/investment.svg" alt=""/>
                            </div>
                            <div class="item">
                                <img src="assets/images/determine.svg" alt=""/>
                            </div>
                            <div class="item">
                                <img src="assets/images/5-question.svg" alt=""/>
                            </div>
                        </div> */}
              <Carousel
                additionalTransfrom={0}
                arrows
                autoPlay
                autoPlaySpeed={2000}
                centerMode={false}
                className=""
                containerClass="container-with-dots"
                dotListClass=""
                draggable
                focusOnSelect={false}
                infinite
                itemClass=""
                keyBoardControl
                minimumTouchDrag={80}
                pauseOnHover
                renderArrowsWhenDisabled={false}
                renderButtonGroupOutside={false}
                renderDotsOutside={false}
                responsive={{
                  desktop: {
                    breakpoint: {
                      max: 3000,
                      min: 1024
                    },
                    items: 4,
                    partialVisibilityGutter: 40
                  },
                  mobile: {
                    breakpoint: {
                      max: 464,
                      min: 0
                    },
                    items: 1,
                    partialVisibilityGutter: 30
                  },
                  tablet: {
                    breakpoint: {
                      max: 1024,
                      min: 464
                    },
                    items: 1,
                    partialVisibilityGutter: 30
                  }
                }}
                rewind={false}
                rewindWithAnimation={false}
                rtl={false}
                shouldResetAutoplay
                showDots={false}
                sliderClass=""
                slidesToSlide={1}
                swipeable
              >
                <div class="image-container increase-size">
                  <img src="assets/images/investment.svg" alt="" style={{ width: "100%", cursor: "pointer" }} />
                </div>
                <div class="image-container increase-size">
                  <img src="assets/images/determine.svg" alt="" style={{ width: "100%", cursor: "pointer" }} />
                </div>
                <div class="image-container increase-size">
                  <img src="assets/images/5-question.svg" alt="" style={{ width: "100%", cursor: "pointer" }} />
                </div>
                <div class="image-container increase-size">
                  <img src="assets/images/investment.svg" alt="" style={{ width: "100%", cursor: "pointer" }} />
                </div>
                <div class="image-container increase-size">
                  <img src="assets/images/determine.svg" alt="" style={{ width: "100%", cursor: "pointer" }} />
                </div>
                <div class="image-container increase-size">
                  <img src="assets/images/5-question.svg" alt="" style={{ width: "100%", cursor: "pointer" }} />
                </div>
                <div class="image-container increase-size">
                  <img src="assets/images/investment.svg" alt="" style={{ width: "100%", cursor: "pointer" }} />
                </div>
                <div class="image-container increase-size">
                  <img src="assets/images/determine.svg" alt="" style={{ width: "100%", cursor: "pointer" }} />
                </div>
                <div class="image-container increase-size">
                  <img src="assets/images/5-question.svg" alt="" style={{ width: "100%", cursor: "pointer" }} />
                </div>
                <div class="image-container increase-size">
                  <img src="assets/images/investment.svg" alt="" style={{ width: "100%", cursor: "pointer" }} />
                </div>
                <div class="image-container increase-size">
                  <img src="assets/images/determine.svg" alt="" style={{ width: "100%", cursor: "pointer" }} />
                </div>
                <div class="image-container increase-size">
                  <img src="assets/images/5-question.svg" alt="" style={{ width: "100%", cursor: "pointer" }} />
                </div>

              </Carousel>
            </div>
          </div>
        </div>
        <div class="row d-none d-md-block">
          <div class="col text-center">
            <img src="assets/images/MacBook.png" alt="" class="img-fluid" />
          </div>
        </div>
        <div class="row d-block d-md-none mt-3">
          <div class="col">
            <img src="assets/images/MacBook-mobile.svg" alt="" class="img-fluid" />
          </div>
        </div>
      </div>




      <div class="row mt-md-3 mt-4">
        <div class="col">
          <div class="container">
            <div class="row my-4">
              <div class="col text-end">
                <a href="javascript:void(0);" onClick={handleBack}>
                  <img
                    class="arrow_next1"
                    src="assets/images/left-arrowpng.png"
                    alt=""
                  />
                </a>
                <a href="javascript:void(0);" class="ms-1" onClick={handleNext}>
                  <img
                    class="arrow_next"
                    src="assets/images/right-arrow.svg"
                    alt=""
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

    </>
  )
}
